import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  
  const location = useLocation();

  useEffect(() => {
    
    if(location.hash){//if there is an id to go to
          const targetHash = document.getElementById(location.hash.slice(1));
      if (targetHash) {
        const offset = 70; // Adjust this value to the height of your fixed header/navigation bar
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = targetHash.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }else{
        window.scrollTo(0, 0);
    }


  }, [location.pathname, location.hash]);
  return null;
}

export default ScrollToTop;